import { Pagination } from '@material-ui/lab';
import { Fade, LinearProgress, Tooltip, Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Container, GlobalStyle } from 'styles/general';
import TitleHead from 'components/TitleHead';
import Layout from 'containers/layouts/layout';
import Environment from 'utils/environments';
import {
  getFilterOptions,
  handleFilterOptions
} from 'utils/handleFilterActions';
import Axios from 'axios';
import ItemsPerPage from 'components/ItemsPerPage';
import PageTitleAndFilter from 'components/PageTitleAndFilter';
import ConfirmModal from 'components/Dialogs/ConfirmModal/ConfirmModal';
import CommonAlert from 'components/CommonAlert/CommonAlert';
import StoreDialog from './dialogs/StoreDialog';

const StoresList = ({ userInfo }) => {
  const environments = Environment(process.env.REACT_APP_ENV);
  const activeRestaurantId = userInfo.companiesActive.id;
  const userLocal = JSON.parse(localStorage.getItem('companies'));
  const profile = userInfo?.profile[0][0]?.name;
  const isLabelAdmin = profile === 'admin_label';

  const [filtersChanged, setFiltersChanged] = useState([]);
  const [callSettings, setCallSettings] = useState({
    page: 1,
    totalPages: 0,
    size: 100,
    stores: [],
    numberOfElements: 0,
    loading: true,
    totalElements: 0
  });
  const {
    page,
    size,
    totalPages,
    stores,
    numberOfElements,
    totalElements,
    loading
  } = callSettings;
  const subGroupOptions = useState(
    userInfo?.companies.groups
      .reduce((acc, group) => [...acc, group.subGroups], [])
      .flat()
  );
  const storeOptions = useState(
    userInfo?.companies.groups
      .reduce((acc, group) => [...acc, group.subGroups], [])
      .flat()
      .reduce((acc, subGroup) => [...acc, subGroup.stores], [])
      .flat()
  );
  const [filterFields, setFilterFields] = useState([
    [
      {
        label: 'Loja',
        filterName: 'restaurantDescription',
        filterNameSecond: 'restaurantId',
        placeHolder: 'Selecione...',
        type: 'autoComplete',
        key: 'stores',
        optionReference: 'description',
        options: storeOptions[0],
        size: 'large',
        searchByTermMode: true
      },
      {
        label: 'Subgrupo',
        filterName: 'subGroupDescription',
        filterNameSecond: 'subGroupId',
        placeHolder: 'Selecione...',
        type: 'autoComplete',
        key: 'subGroup',
        optionReference: 'description',
        options: subGroupOptions[0],
        size: 'large',
        searchByTermMode: true
      },
      {
        label: 'Marca',
        filterName: 'flagDescription',
        filterNameSecond: 'flagId',
        placeHolder: 'Selecione...',
        type: 'autoComplete',
        urlPath: `${environments.catalog}/flags`,
        key: 'flags',
        optionReference: 'description',
        options: [],
        size: 'large',
        searchByTermMode: true
      }
    ]
  ]);
  const [message, setMessage] = useState({
    description: '',
    status: ''
  });

  const [modalSettings, setModalSettings] = useState([
    { id: 1, name: 'storeDialog', open: false },
    { id: 2, name: 'confirmDialog', store: null, open: false }
  ]);

  const getFilterHandle = (urlPath, label, key, optionReference) => {
    getFilterOptions(
      urlPath,
      label,
      key,
      filterFields,
      setFilterFields,
      optionReference,
      userLocal?.labelId,
      '',
      page
    );
  };

  const handleFilter = (param, value, _, paramSecond) => {
    const hasFilterWithFirstName = filtersChanged?.filter(
      (el) => el?.param === param
    )?.length;
    const hasFilterWithSecondName = filtersChanged?.filter(
      (el) => el?.param === paramSecond
    )?.length;

    let formattedFilters = hasFilterWithSecondName
      ? filtersChanged?.filter((el) => el?.param !== paramSecond)
      : filtersChanged;

    if (!value && (hasFilterWithFirstName || hasFilterWithSecondName)) {
      formattedFilters = filtersChanged?.filter(
        (el) => el?.param !== paramSecond && el?.param !== param
      );
    }

    handleFilterOptions(
      param,
      value,
      formattedFilters,
      setFiltersChanged,
      null,
      false,
      '1'
    );
  };

  const handleDelete = async (id) => {
    const baseUrl = `${environments.catalog}/brands`;

    Axios.delete(`${baseUrl}/${id}`, config)
      .then(() => {
        setModalSettings(
          modalSettings.map((modal) =>
            modal.name === 'confirmDialog'
              ? {
                  ...modal,
                  open: false,
                  store: null
                }
              : modal
          )
        );

        setMessage({
          description: response?.message,
          status: 'success'
        });
      })
      .catch((error) => {
        setMessage({
          description: response?.message,
          status: 'error'
        });
      });
  };

  const getMainContent = async (page, size) => {
    const params = filtersChanged.map((fc) => fc.urlParam).join('&');
    setCallSettings({
      ...callSettings,
      loading: true
    });
    const groupId = userLocal?.companies?.groups?.length
      ? userLocal?.companies?.groups[0]?.id
      : '';
    const groupIdParam = isLabelAdmin ? `&groupId=${groupId}` : '';

    Axios.get(
      `${environments.catalog}/flagsRestaurants?page=${page}&size=${size}${groupIdParam}&${params}`
    )
      .then((response) => {
        setCallSettings({
          ...callSettings,
          totalPages: response?.data?.totalPages,
          stores: response?.data?.content || [],
          numberOfElements: response?.data?.numberOfElements,
          loading: false,
          totalElements: response?.data?.totalElements
        });
      })
      .catch((error) => {
        setMessage({
          description: `Erro ao carregar lojas`,
          status: 'error',
          autoHideDuration: 5000
        });
        setCallSettings({
          ...callSettings,
          loading: false
        });
        console.log(error);
      });
  };

  useEffect(() => {
    setCallSettings({ ...callSettings, page: 1 });
    getMainContent(page, size);
  }, [userLocal?.labelId, filtersChanged]);

  useEffect(() => {
    setCallSettings({
      ...callSettings,
      activeRestaurantId: userLocal?.labelId
    });
  }, [userInfo]);

  return (
    <Layout>
      <TitleHead title="Lojas" />

      <GlobalStyle />

      <Container>
        <PageTitleAndFilter
          title="Lojas"
          activeFilterFilds={filterFields}
          getFilterhandle={getFilterHandle}
          handleFilter={handleFilter}
        />

        <table className="desktop" width="100%" cellPadding="0" cellSpacing="0">
          <thead>
            <tr className="headerTitle">
              <th style={{ width: '30%' }} className="subtitle">
                LOJA
              </th>

              <th
                style={{ width: '20%', borderLeft: 'solid 1px #D0D3E2' }}
                className="subtitle pl12 pr12"
              >
                SUBGRUPO
              </th>

              <th
                style={{ width: '50%', borderLeft: 'solid 1px #D0D3E2' }}
                className="subtitle"
              >
                MARCAS
              </th>
            </tr>
          </thead>

          {loading && (
            <tr>
              <th colSpan={3} className="m10 textAlignCenter">
                <LinearProgress
                  style={{ height: '7px' }}
                  id="loading"
                  variant="query"
                />
              </th>
            </tr>
          )}

          <tbody>
            {stores?.map((store) => (
              <>
                <tr key={store.id}>
                  <td className="p10">
                    <span
                      id="editStoreButton"
                      className="linkElement fontSizeDefault"
                      onClick={() => {
                        setModalSettings(
                          modalSettings.map((modal) =>
                            modal.name === 'storeDialog'
                              ? { ...modal, open: true, store }
                              : modal
                          )
                        );
                      }}
                    >
                      {store?.companyName}
                    </span>
                  </td>

                  <td
                    style={{ borderLeft: 'solid 1px #D0D3E2' }}
                    className="pr12 pl12 fontSizeDefault"
                  >
                    {store?.subgroup}
                  </td>

                  <td
                    style={{ borderLeft: 'solid 1px #D0D3E2' }}
                    className="actionButton pr12 pl12 fontSizeDefault"
                  >
                    <Tooltip
                      TransitionComponent={Fade}
                      TransitionProps={{ timeout: 600 }}
                      title={
                        store?.flags?.length ? (
                          store.flags.map((flag, index) => (
                            <p
                              style={{
                                marginBottom:
                                  store?.flags?.length - 1 === index
                                    ? '0'
                                    : '5px'
                              }}
                            >
                              {flag.description}
                            </p>
                          ))
                        ) : (
                          <p className="mb0">Nenhum registro</p>
                        )
                      }
                    >
                      <span
                        onClick={() => {
                          setModalSettings(
                            modalSettings.map((modal) =>
                              modal.name === 'storeDialog'
                                ? { ...modal, open: true, store }
                                : modal
                            )
                          );
                        }}
                        className="linkElement"
                      >
                        {store?.flags?.length || 0}
                      </span>
                    </Tooltip>
                  </td>
                </tr>

                <tr>
                  <td colSpan={3}>
                    <hr />
                  </td>
                </tr>
              </>
            ))}

            {!stores?.length ? (
              <tr className="emptyTableLineInfo">
                <th style={{ margin: '10px', textAlign: 'center' }} colSpan={3}>
                  Nenhuma loja encontrada
                </th>
              </tr>
            ) : null}
          </tbody>
        </table>

        <div className="pagination">
          <Pagination
            count={totalPages}
            onChange={(_, page) => {
              setCallSettings({ ...callSettings, page });
              getMainContent(page, size);
            }}
            variant="outlined"
            shape="rounded"
            size="small"
            color="primary"
          />

          <ItemsPerPage
            numberOfElements={numberOfElements}
            size={totalElements}
          />
        </div>

        {modalSettings?.find((modal) => modal?.name === 'storeDialog')?.open ? (
          <StoreDialog
            open={
              !!modalSettings?.find((modal) => modal?.name === 'storeDialog')
                ?.open
            }
            onClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'storeDialog'
                    ? { ...modal, open: false, store: undefined }
                    : modal
                )
              );
            }}
            store={
              modalSettings?.find((modal) => modal?.name === 'storeDialog')
                ?.store
            }
            onSuccess={() => {
              setMessage({
                description: 'Restaurante atualizado com sucesso',
                status: 'success'
              });
              getMainContent(page, size);
            }}
          />
        ) : null}

        {modalSettings.find((modal) => modal.name === 'confirmDialog')
          ?.open && (
          <ConfirmModal
            open={
              modalSettings.find((modal) => modal.name === 'confirmDialog').open
            }
            title={`Deseja realmente excluir ${
              modalSettings.find((modal) => modal.name === 'confirmDialog')
                ?.store?.description
            }?`}
            content={
              <Typography className="bold pt10">
                Esta ação não pode ser desfeita. Deseja continuar?
              </Typography>
            }
            onClose={() => {
              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'confirmDialog'
                    ? {
                        ...modal,
                        open: false,
                        store: null
                      }
                    : modal
                )
              );
            }}
            cancelText="Não"
            onConfirm={() => {
              handleDelete(
                modalSettings.find((modal) => modal.name === 'confirmDialog')
                  ?.store?.id
              );

              setModalSettings(
                modalSettings.map((modal) =>
                  modal.name === 'confirmDialog'
                    ? {
                        ...modal,
                        open: false,
                        store: null
                      }
                    : modal
                )
              );
            }}
            confirmText="Sim"
          />
        )}

        <CommonAlert
          open={!!message?.description}
          severity={message?.status}
          onClose={() => {
            setMessage({
              description: '',
              status: ''
            });
          }}
          messagePersonal={message?.description}
          autoHideDuration={2000}
        />
      </Container>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  userInfo: state.user
});

export default connect(mapStateToProps)(StoresList);
